// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + "MainContainer" + "." + "01cc7a58" + ".css?v=5.0.140.0";
};